import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { NavigationRoutes } from '../../constants/navigationRoutes';
import { BadgeNewNavDesktop } from '../Badge/BadgeNew.styled';
import { AccessoriesPanel } from './components/AccessoriesPanel/AccessoriesPanel';
import { BrowseCollectionsPanel } from './components/BrowseCollectionsPanel/BrowseCollectionsPanel';
import { BrowsePostersPanel } from './components/BrowsePostersPanel/BrowsePostersPanel';
import { ComicGameWorldsPanel } from './components/ComicGameWorldsPanel/ComicGameWorldsPanel';
import { LimitedEditionsPanel } from './components/LimitedEditionsPanel/LimitedEditionsPanel';
import { Container, List } from './NavigationBar.styled';
import NavigationBarItem from './NavigationBarItem';
export const NavigationBar = forwardRef(({ isSearchBarVisible }, ref) => {
    const navigationBarItems = [
        {
            id: 'browse-posters',
            url: NavigationRoutes.BROWSE_POSTERS,
            label: 'Browse Posters',
            panel: BrowsePostersPanel,
            connected: true,
        },
        {
            id: 'explore-collections',
            url: NavigationRoutes.BROWSE_COLLECTIONS,
            label: 'Explore Collections',
            panel: BrowseCollectionsPanel,
            connected: true,
        },
        {
            id: 'discover-brands',
            url: NavigationRoutes.BROWSE_BRANDS,
            label: 'Discover Brands',
            panel: ComicGameWorldsPanel,
            connected: true,
        },
        {
            id: 'limited-editions',
            label: 'Limited Displates',
            panel: LimitedEditionsPanel,
            connected: true,
        },
        {
            id: 'accessories',
            label: 'Accessories & Gifts',
            panel: AccessoriesPanel,
            connected: true,
            badge: _jsx(BadgeNewNavDesktop, {}, void 0),
        },
        {
            id: 'whats-displate',
            url: NavigationRoutes.WHATS_DISPLATE,
            label: "What's a Displate",
        },
    ];
    return (_jsx(Container, Object.assign({ ref: ref, isSearchBarVisible: isSearchBarVisible }, { children: _jsx(List, Object.assign({ isSearchBarVisible: isSearchBarVisible }, { children: navigationBarItems.map((item) => (_jsx(NavigationBarItem, { isSearchBarVisible: isSearchBarVisible, navigationItem: item }, item.id))) }), void 0) }), void 0));
});
//# sourceMappingURL=NavigationBar.js.map